import { NavigationLink } from "../NavigationLink/NavigationLink";

export function PageSelectionButton(props) {
    return (
        <div
            className="z-20 h-full w-full"
            onClick={props.onClick}
        >
            <NavigationLink
                className={`!justify-start !text-inherit !text-left w-full h-full px-12 py-6 hover:bg-pine !text-pine hover:!text-white ${
                    props.className ? props.className : ""
                }`}
                content={props.content}
                target={props.target}
            />
        </div>
    );
}
